import Axios from 'axios'

const token = {
  axios() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.BACKEND_URL
    return AxiosInstance
  },
  callTokenChromatoxService() {
    return this.axios().get('/token/chromatox')
  },
  callTokenLaudasaService() {
    return this.axios().get('/token/laudasa')
  }
}

export default token
